'use client';

import type { PropsWithChildren } from 'react';

import { useScrollState } from '@core/Hooks/UseScrollState';
import useBreakpoint from '@gds/Pagination/Hooks/UseBreakpoint.hook';

import styles from './PrimaryHeaderNav.module.css';

type PrimaryHeaderNavClientWrapperProps = {
  className?: string;
} & PropsWithChildren;

const HERO_H_DESKTOP = 380;
const TABS_OFFSET = 56;

export const PrimaryHeaderNavClientWrapper = ({
  children,
  className,
}: PrimaryHeaderNavClientWrapperProps) => {
  const thresholds = {
    blur: 1,
    removeTransparency: HERO_H_DESKTOP - TABS_OFFSET,
  };

  const {
    breakpoints: { isTabletL, isDesktop },
  } = useBreakpoint();

  const noScrollBehavior = !isTabletL && !isDesktop;

  const { scrollState } = useScrollState({ thresholds, isDisabled: noScrollBehavior });

  return (
    <div
      className={`${styles.wrapper} ${scrollState.blur ? styles.blur : undefined} ${scrollState.removeTransparency ? styles.removeTransparency : undefined} ${className}`}
    >
      {children}
    </div>
  );
};
